<template>
  <modal
    :show.sync="showEditModalDriver"
    bodyClasses="pt-0"
    size="lg"
    @close="closeModal"
  >
    <template slot="header" class="pb-0">
      <h6 class="subtitle" id="modal-title-default">
        Edit Driver
      </h6>
    </template>
    <div class="row forms mt-4">
      <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-12">
        <label for="title" class="title-label">Gender</label>

        <b-form-group v-slot="{ ariaDescribedby }" class="mb-0">
          <b-form-radio-group
            id="radio-gender"
            v-model="tempDriver.person.gender"
            :aria-describedby="ariaDescribedby"
            name="radio-gender"
            buttons
            button-variant="outline-neutral"
            size="md"
          >
            <b-form-radio value="male" class="pc-1">Mr.</b-form-radio>
            <b-form-radio value="female" class="pc-1">Mrs.</b-form-radio>
            <b-form-radio value="other" class="pc-1">Mx.</b-form-radio>
          </b-form-radio-group>
        </b-form-group>
      </div>

      <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12">
        <base-input
          v-model.trim="$v.tempDriver.person.first_name.$model"
          inputClasses="text-capitalize"
          label="First Name"
          placeholder="First Name"
          id="ncfirst_name_driverModal"
          name="ncfirst_name_driverModal"
          tab-index="15"
          markrequired
          :error="
            !$v.tempDriver.person.first_name.minLength ||
            $v.tempDriver.person.first_name.$error
              ? `Minimum ${$v.tempDriver.person.first_name.$params.minLength.min} letters.`
              : ''
          "
        />
      </div>

      <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12">
        <base-input
          v-model.trim="$v.tempDriver.person.last_name.$model"
          label="Last Name"
          inputClasses="text-capitalize"
          placeholder="Last Name"
          id="nclast_name_driverModal"
          name="nclast_name_driverModal"
          tab-index="16"
          :error="
            !$v.tempDriver.person.last_name.minLength ||
            $v.tempDriver.person.last_name.$error
              ? `Minimum ${$v.tempDriver.person.last_name.$params.minLength.min} letters.`
              : ''
          "
        />
      </div>

      <div
        class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 inputphone"
        v-bind:class="{
          'is-invalid': $v.tempDriver.person.numbre_phone.$error
        }"
      >
        <label class="title-label"
          ><span class="markrequired">*</span>Contact Number</label
        >
        <vue-tel-input
          v-model="phoneNumber"
          key="NumberPhoneCustomer"
          inputId="NumberPhoneCustomerModal"
          name="NumberPhoneCustomerModal"
          required
          mode="international"
          inputClasses="input no-label no-err"
          :dynamicPlaceholder="true"
          :disabledFetchingCountry="true"
          :validCharactersOnly="true"
          :wrapperClasses="[
            $v.tempDriver.person.numbre_phone.$error ? 'is-invalid' : '',
            'mb-0'
          ]"
          @input="phoneNumberEvent"
        ></vue-tel-input>
        <small
          class="invalid-feedback mt-1"
          v-if="$v.tempDriver.person.numbre_phone.$error"
          >Enter a valid phone</small
        >
      </div>

      <div class="col-12 text-right">
        <base-button
          :disabled="send"
          type="primary"
          class="min-button mb-0"
          @click="saveDriver()"
        >
          <i class="flaticon-floppy-disk"></i> Save
        </base-button>
      </div>
    </div>
  </modal>
</template>

<script>
import lodash from "lodash";
import { mapGetters, mapActions, mapMutations } from "vuex";
import WSelect from "@/components/Select";
import { VueTelInput } from "vue-tel-input";
import { DriversAPI } from "../../../core/api";
import {
  required,
  minLength,
  maxLength,
  helpers
} from "vuelidate/lib/validators";
const ValName = helpers.regex("alphaCha", /^[a-zA-ZÑñáéíóúüüÜÁÉÍÓÚ'-\s]*$/);
import moment from "moment";

WSelect.computed.readonly = function() {
  const isIE = !this.$isServer && !Number.isNaN(Number(document.documentMode));
  return (
    !this.filterable ||
    this.multiple ||
    (!isIE && !this.visible && !this.remote)
  );
};

export default {
  name: "add-driver",
  components: {
    VueTelInput,
    WSelect
  },
  props: {
    show: {
      type: Boolean,
      default: false,
      description: "(closeable)"
    },
    driverId: {
      type: [String],
      default: null
    },
    driver: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      tempDriver: {
        person: {
          first_name: "",
          last_name: "",
          full_name: "",
          gender: "",
          numbre_phone: ""
        },
        relationship: {
          branch: ""
        }
      },
      send: false,
      type: "driver",
      phoneNumber: "",
      showEditModalDriver: false
    };
  },
  async created() {
    if (this.driver) {
      this.tempDriver = {
        person: {
          first_name: this.driver.person.first_name,
          last_name: this.driver.person.last_name,
          full_name: this.driver.person.full_name,
          gender: this.driver.person.gender,
          numbre_phone: this.driver.person.numbre_phone
        },
        relationship: {
          branch: this.driver.relationship.branch
        }
      };
      this.phoneNumber = this.tempDriver.person.numbre_phone;
    }
  },
  watch: {
    show: {
      handler: function(current, old) {
        this.showEditModalDriver = current;
      },
      deep: true
    },
    driver: {
      handler: function(current, old) {
        if (current) {
          this.tempDriver = {
            person: {
              first_name: current.person.first_name,
              last_name: current.person.last_name,
              full_name: current.person.full_name,
              gender: current.person.gender,
              numbre_phone: current.person.numbre_phone
            },
            relationship: {
              branch: current.relationship.branch
            }
          };
          this.phoneNumber = this.tempDriver.person.numbre_phone;
        }
      },
      deep: true
    }
  },
  methods: {
    async saveDriver() {
      if (!this.$v.tempDriver.$invalid) {
        let driver = lodash.cloneDeep(this.tempDriver);
        driver.person.full_name = `${driver.person.first_name} ${driver.person.last_name}`;
        this.updateDriverById(this.driverId, this.getTempDriver(driver));
      } else {
        this.$v.driver.$touch();
        this.$notify({
          type: "warning",
          title: "Important!",
          message: "Please complete the required attributes",
          icon: "flaticon-warning-1"
        });
      }
    },
    async updateDriverById(driverId, driver) {
      try {
        this.send = true;
        let { data } = await DriversAPI.updateAnyAttribute(
          driverId,
          driver,
          this.sesion.token
        );
        this.send = false;
        if (data.status) {
          let { driver } = data.data;
          if (driver) {
            this.$notify({
              type: "success",
              title: "Success!",
              message: "The Driver has been Saved",
              icon: "flaticon-check-mark"
            });
            this.$emit("change", driver);
            this.clearData();
          } else {
            this.$notify({
              type: "danger",
              title: "Error!",
              message: "There was an error saving the Driver, please try again",
              icon: "flaticon-remove"
            });
          }
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "There was an error saving the Driver, please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.send = false;
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "There was an error saving the Driver, please try again",
          icon: "flaticon-remove"
        });
      }
    },
    phoneNumberEvent(value, payload) {
      let result = payload;
      if (result.isValid) {
        this.driver.person.numbre_phone = result.number.e164;
        this.$v.driver.person.numbre_phone.$model = value;
      } else {
        this.driver.person.numbre_phone = value;
        this.$v.driver.person.numbre_phone.$model = value;
      }
    },
    clearData() {
      this.tempDriver = {
        person: {
          first_name: this.driver.person.first_name,
          last_name: this.driver.person.last_name,
          full_name: this.driver.person.full_name,
          gender: this.driver.person.gender,
          numbre_phone: this.driver.person.numbre_phone
        },
        relationship: {
          branch: this.driver.relationship.branch
        }
      };
      this.phoneNumber = this.driver.person.numbre_phone;
      this.$v.tempDriver.$reset();
    },
    closeModal() {
      this.clearData();
      this.$emit("close", false);
    },
    getTempDriver(driver) {
      return {
        "person.first_name": driver.person.first_name,
        "person.last_name": driver.person.last_name,
        "person.full_name": driver.person.full_name,
        "person.gender": driver.person.gender,
        "person.numbre_phone": driver.person.numbre_phone,
        "relationship.branch": driver.relationship.branch
      };
    }
  },
  computed: {
    ...mapGetters(["sesion"])
  },
  validations: {
    tempDriver: {
      person: {
        first_name: {
          required,
          minLength: minLength(2),
          maxLength: maxLength(20),
          ValName
        },
        last_name: {
          minLength: minLength(2),
          maxLength: maxLength(20),
          ValName
        },
        numbre_phone: {
          required,
          minLength: minLength(7),
          maxLength: maxLength(25)
        }
      }
    }
  }
};
</script>
